module.exports = __webpack_public_path__ + "img/process@2x-100.7f352cdc.jpg";